// extracted by mini-css-extract-plugin
export var accentColor = "#07c";
export var categoryBorderColor = "#07c";
export var disableRipple = "false";
export var fontFamily = "\"Roboto\",\"Helvetica\",\"Arial\",sans-serif";
export var mainColor = "#07c";
export var mainContrast = "#fff";
export var panelBorderColor = "#07c";
export var secondaryColor = "#07c";
export var secondaryContrast = "#fff";